export const TYPE_NON      = null
export const TYPE_NONE     = -1
export const TYPE_INCLUDED = 1
export const TYPE_PENDING  = 0
export const TYPE_MAYBE    = 2
